import { lazy } from 'react';
export const AdminPage = lazy(() => import(/* webpackChunkName: "admin" */ '.'));
export default AdminPage;
